import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type Delivery,
  type ListRouteParams,
} from "../../../domain/entities/delivery";
import { type DeliveriesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listRoute = createAsyncThunk<
  Delivery[],
  ListRouteParams,
  {
    dispatch: DeliveriesDispatch;
    extra: ExtraArgument;
    state: State;
  }
>(thunkTypes.LIST_ROUTE, async (params, { extra }) => {
  return await extra.deliveryRepo.listRoute(params);
});
